import { React, useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation, Navigate, useOutletContext } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import ContentPasteSearchRoundedIcon from '@mui/icons-material/ContentPasteSearchRounded';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import CloseIcon from '@mui/icons-material/Close';
// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    Box,
    Typography,
    InputAdornment,
    CardContent,
    Grid,
    FormLabel,
    Modal,
    TextareaAutosize
} from '@mui/material';
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
} from '@mui/lab';

import { Icon } from '@iconify/react';
import Moment from 'moment';
import Iconify from '../../Iconify';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import URLS from '../../../services/urls.service';
import Page from '../../Page';
import AppCache from '../../../services/AppCache';
import StickyHeader from '../../Common/StickyHeader';


// ----------------------------------------------------------------------
const historyModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};


// ----------------------------------------------------------------------
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};
export default function IssueTracker() {

    const { onOpenSidebar, open, onCloseSidebar, previousPath, currentPath } = useOutletContext();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser?.ExecutiveId;
    // dropdown
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState();

    const [site, setSite] = useState("");
    const [selectedSite, setSelectedSite] = useState([]);

    const [category, setCategory] = useState('');
    const [selectedCategory, setSelectedCategory] = useState([]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [status, setStatus] = useState('');
    const [selectedStatus, setSelectedStatus] = useState([]);

    const [editData, setEditData] = useState([]);
    const [searchIssueId, setSearchIssueId] = useState('');
    const [comment, setComment] = useState("");

    // RCA
    const [reasonOpenModal, setReasonOpenModal] = useState(false);
    const [rcaDate, setRcaDate] = useState(format(new Date(), "dd-MMM-yyyy"));
    const [reasonDdl, setReasonDdl] = useState("");
    const [selectedReasonDdl, setSelectedReasonDdl] = useState([]);
    const [reasonTxt, setReasonTxt] = useState("");
    const [solution, setSolution] = useState("");
    const [recurring, setRecurring] = useState(true);
    const [occurrence, setOccurrence] = useState("");
    const [selectedIssue, setSelectedIssue] = useState("");
    const [rcaSolutionPreview, setRcaSolutionPreview] = useState("");

    const [data, setData] = useState([]);
    const [serviceHistoryData, setServiceHistoryData] = useState([]);
    const [showCards, setShowCards] = useState(false);

    const RecurringDropdown = [
        { Id: true, value: 'Yes' },
        { Id: false, value: 'No' },
    ];

    const UserClientId = CurrentLoggedInUser?.UserClientId;

    const handleSite = (newValue) => {
        const siteId = newValue?.SiteId || 0;
        setSite(siteId);
    }
    const handleCategory = (newValue) => {
        setCategory(newValue?.Id || "");
    };
    const handleStatus = (newValue) => {
        setStatus(newValue?.Id || "");
    };

    const handleEffFrom = (newValue) => {
        setFromDate(newValue)
    };
    const handleEffTo = (newValue) => {
        setToDate(newValue)
    };

    const onFilterClick = () => {
        setIsLoading(true);
        setShowCards(false);
        setFilterData([]);

        const payload = {
            "UserId": String(userId),
            "FromDate": fromDate ? Moment(fromDate).format('DD-MMM-YYYY') : "",
            "ToDate": fromDate ? Moment(toDate).format('DD-MMM-YYYY') : "",
            "IssueCategoryId": category || 0,
            "SiteId": site || 0,
            "Status": String(status) || "",
            "ClientId": UserClientId
        }
        URLS.filterIssueTracker(payload)
            .then((response) => {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const data = Array.isArray(response.data) ? response.data : [];

                    setFilterData(data);
                    setShowCards(true);
                    enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                } else {
                    setFilterData([]);
                    setShowCards(false);
                    enqueueSnackbar("Record Not Found.", { variant: 'error' });
                }
                setIsLoading(false);
            })
            .catch(error => {
                setShowCards(false);
                setIsLoading(false);
                enqueueSnackbar("Record Not Found.", { variant: 'error' });

                console.log("error", error)
            });

    };
    console.log("filterData", filterData)

    const handleReset = () => {
        setSite("");
        setCategory("");
        setFromDate(null);
        setToDate(null);
        setStatus("");
        setShowCards(false);
        setSelectedIssue("");
        setFilterData([]);
        setReasonOpenModal(false);
        setSearchIssueId("");
        setIsLoading(false);

    };
    const handleIssueCardClick = (issue) => {

        console.log("clicked issue:", issue);
        setSelectedIssue(issue);
        const statusPayload = {
            "IssueId": issue?.IssueId || 0,
            "SiteId": issue?.ClientId || 0,
            "ClientId": issue?.SiteId || 0
        };

        URLS.loadStatus(statusPayload)
            .then((response) => {
                if (response.status === 200 && response.data) {

                    const statusData = response.data;
                    setData(statusData);

                    if (statusData?.IsRCA && statusData?.IssueRCAId) {
                        URLS.loadIssueRCAData({
                            IssueRCAId: statusData.IssueRCAId
                        })
                            .then((rcaRes) => {
                                const rcaData = rcaRes.data?.[0] || {};

                                // RCA card preview
                                setRcaSolutionPreview(rcaData?.Solution || "");

                                // Modal data
                                setReasonDdl(rcaData?.ReasonId || "");
                                setReasonTxt(rcaData?.Reason || "");
                                setSolution(rcaData?.Solution || "");
                                setRecurring(rcaData?.IsRecurring ?? true);
                                setOccurrence(rcaData?.Occurrence || "");
                                setRcaDate(
                                    rcaData?.RCADate
                                        ? rcaData.RCADate
                                        : format(new Date(), "dd-MMM-yyyy")
                                );
                            })
                            .catch(err =>
                                console.error("Error in loadIssueRCAData", err)
                            );
                    }
                }
            })
            .catch(error => {
                console.error("Error in loadStatus", error);
            });

        URLS.filterServiceByIssue({ IssueID: issue?.IssueId, ClientId: UserClientId })
            .then((response) => {
                if (response.status === 200) {
                    setServiceHistoryData(response.data)

                }
                console.log("cellValues", response.data, " response.data", response)

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    };

    const handelReasonOpenClick = () => {
        setReasonOpenModal(true);
    };

    const handelReasonCancelClick = () => {
        setReasonOpenModal(false);
    };
    const handleComment = (e) => {
        setComment(e.target.value)

    };
    const handleSend = () => {
        const currentDate = Moment().format("YYYY-MM-DD");
        const currentTime = Moment().format("h:mm A");

        const formData = new FormData();
        const servicePayload = {
            IssueId: selectedIssue?.IssueId || "",
            SiteId: selectedIssue?.SiteId || 0,
            ClientId: 0,
            ProjectId: 0,
            ActivityId: 0,
            StartTime: currentTime,
            ToTime: "",
            Date: currentDate,
            ServiceRemark: "",
            ServiceProvided: comment || "",
            PhoneNo: "",
            ServiceInMinute: 1,
            UserID: userId,
            ServiceTypeId: 27,
            Status: status || 0,
            IsClientShow: 1,
            IsIssueTrackerDashboardTrue: true
        };

        Object.keys(servicePayload).forEach((key) => {
            formData.append(`saveservice[0][${key}]`, servicePayload[key]);
        });
        URLS.insertUpdateServiceEntry(formData)
            .then((response) => {
                if (response.status === 200) {
                    URLS.filterServiceByIssue({ IssueID: serviceHistoryData[0]?.IssueId, ClientId: UserClientId })
                        .then((response) => {
                            if (response.status === 200) {
                                setComment("");
                                setServiceHistoryData(response.data)

                            }
                            console.log("cellValues", response.data, " response.data", response)

                        })
                        .catch(error => {
                            // On error
                            console.log(" Error ");
                        });
                    enqueueSnackbar(
                        response.data?.message || "Service saved successfully!",
                        { variant: "success" }
                    );
                }
            })
            .catch((error) => {
                enqueueSnackbar(
                    error.response?.data?.message || "Service not saved.",
                    { variant: "error" }
                );
            });
    }

    useEffect(() => {
        URLS.getClientWiseDistributorDDL({ userId })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);
            })
            .catch(() => {
                console.log("Error");
            });
        URLS.loadIssueCategory()
            .then((response) => {
                setSelectedCategory(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadStatusDropDown()
            .then((response) => {
                console.log("res", response)
                setSelectedStatus(Array.isArray(response.data) ? response.data : []);
            })
            .catch((error) => {
                console.error("Error loading tracker data:");
            });
        URLS.getRCAReasonList({ ExecutiveId: userId })
            .then((response) => {
                const reasonList = Array.isArray(response.data) ? response.data : [];
                setSelectedReasonDdl(reasonList);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);

    const filteredServiceData = searchIssueId?.trim()
        ? (filterData ?? []).filter(
            item => String(item?.IssueId ?? "") === searchIssueId.trim()
        )
        : (filterData ?? []);

    const statusStyles = {
        pending: {
            border: "1px solid #FFE7CA",
            bg: "#FFE7CA",
            textColor: "#FF4602",
        },
        completed: {
            border: "1px solid #DFF9E0",
            bg: "#F3FFF4",
            textColor: "#2E7D32",
        },
        onHold: {
            border: "1px solid #EAE6E6",
            bg: "#F5F5F5",
            textColor: "#595555",
        },
    };

    const getStatusKey = (statusName) => {
        const value = (statusName ?? "").toString().trim().toLowerCase();

        if (value === "completed") return "completed";
        if (value === "on hold") return "onHold";

        return "pending"; // fallback
    };

    const statusKey = getStatusKey(selectedIssue?.StatusName);

    const getColor = (label) => {
        switch (label) {
            case 'Allocated':
                return '#2B7FFF'; // Blue
            case 'WIP':
                return '#F0B100'; // Yellow
            case 'Resolved':
                return '#00C951'; // Green
            case 'UnAllocated':
                return '#9CA3AF'; // grey
            case 'On Hold - Client':
                return '#FF6900'; // Orange
            case 'On hold - Executive':
                return '#FB2C36'; // Red
            case 'On Hold - SAPL':
                return '#AD46FF'; // Purple
            case 'Pending For Release':
                return '#615FFF'; // Brown
            case 'To Be Validated':
                return '#FFA25F'; // Brown
            default:
                return '#bdbdbd'; // Grey fallback
        }
    };
    // Compute status style dynamically
    const statusWiseStyle = (() => {
        const color = getColor(selectedIssue?.StatusName || ""); // fallback to default
        return {
            border: `1px solid ${color}`,
            bg: `${color}20`, // light background, 20% opacity
            textColor: color,
        };
    })();



    const statusIconMap = {
        pending: (
            <ScheduleIcon sx={{ color: "#53735F", width: 17, height: 17 }} />
        ),
        completed: (
            <CheckCircleOutlineIcon sx={{ color: "#00C951", width: 17, height: 17 }} />
        ),
        onHold: (
            <Icon
                icon="mdi:motion-pause-outline"
                width={17}
                height={17}
                style={{ color: "#53735F" }}
            />
        ),
    };

    const statusIcon = statusIconMap[statusKey] ?? statusIconMap.pending;

    const statusLabelMap = {
        pending: "Total Pending Time",
        completed: "Total Time for Closure",
        onHold: "Total On Hold Duration",
    };

    const statusLabel = statusLabelMap[statusKey] ?? statusLabelMap.pending;

    console.log("service>>>>>>>>>>>>>>", serviceHistoryData,)
    const handleNavigateBack = () => {
        navigate('/dashboard/service/issuetrackerfornonsapl');
    }

    const exportToExcel = () => {
        const payload = {
            UserId: String(userId),
            FromDate: fromDate ? Moment(fromDate).format("DD-MMM-YYYY") : "",
            ToDate: toDate ? Moment(toDate).format("DD-MMM-YYYY") : "",
            IssueCategoryId: category || 0,
            SiteId: site || 0,
            Status: String(status) || "",
            ClientId: UserClientId,
        };


        URLS.downloadIssueTrackerdata(payload)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    console.log("file>>>>", response.data, response.data.FileName)
                    const encodedKey = encodeURIComponent(response.data.FileName); // Encode special characters
                    URLS.downloadExport(encodedKey, { responseType: "blob" }) // API call to get the file
                        .then((response) => {
                            const requestUrl = response.request.responseURL; // Get the actual file URL

                            const link = document.createElement("a");
                            link.href = requestUrl; // Directly use the response URL
                            link.setAttribute("download", encodedKey); // Set the filename
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            enqueueSnackbar("File downloaded successfully.", { variant: 'success' });

                        })
                        .catch((error) => enqueueSnackbar("File download failed.", { variant: 'error' }));
                }
                else {
                    enqueueSnackbar("File download failed.", { variant: 'error' });
                }

            })
            .catch(() => {
                setIsLoading(false);
                enqueueSnackbar("File download failed.", {
                    variant: "error",
                });
            });
    };

    return (

        <Page title="Issue Tracker" >
            <StickyHeader title="Issue Tracker"
                onBack={handleNavigateBack}
                showButton={false}
                showBorder={false}
            />
            <Stack direction="row" alignItems="center" justifyContent="space-between" mt={1.5} spacing={2} px={2}>
                <FormControl
                    size="small"
                    fullWidth
                >
                    <Autocomplete
                        fullWidth
                        size="small"
                        id="site"
                        value={selectedSite.find((item) => item.SiteId === site) || null}
                        onChange={(_, newValue) => handleSite(newValue)}
                        options={selectedSite}
                        getOptionLabel={(option) => option.Name || ""}
                        isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Distributor"
                                variant="outlined"
                            />
                        )}

                        renderOption={(props, option) => (
                            <li {...props} key={option.SiteId}>
                                {option.Name}
                            </li>
                        )}
                    />
                </FormControl>

                <FormControl size="small" fullWidth>
                    <Autocomplete
                        fullWidth
                        size="small"
                        value={selectedCategory.find((item) => item.Id === category) || null}
                        onChange={(_, newValue) => handleCategory(newValue)}
                        options={selectedCategory}
                        getOptionLabel={(option) => option.Name || ""}
                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                        renderOption={(props, option) => (
                            <li {...props} key={option.Id}>
                                {option.Name}
                            </li>
                        )}
                        renderInput={(params) => <TextField {...params} label="Category" />}

                    />
                </FormControl>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker

                        label="From Date"
                        inputFormat="dd/MMM/yyyy"
                        value={fromDate}
                        onChange={handleEffFrom}
                        renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                    />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                        label="To Date"
                        inputFormat="dd/MMM/yyyy"
                        value={toDate}
                        onChange={handleEffTo}
                        renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                    />
                </LocalizationProvider>
                <FormControl size="small" fullWidth>
                    <Autocomplete
                        size="small"
                        id="status"
                        value={selectedStatus.find(
                            (item) => item.Id === status
                        ) || null}
                        onChange={(_, newValue) => handleStatus(newValue)}
                        options={selectedStatus}
                        getOptionLabel={(option) => option.Name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option.Id === value.Id
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Status" />
                        )}

                    />
                </FormControl>


                <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={1}>

                    <Tooltip title="Filter">

                        <Button
                            variant="contained"
                            size="small"
                            sx={{ width: '95px' }}
                            onClick={onFilterClick}
                        >Apply Filter</Button>
                    </Tooltip >
                    <Tooltip title="Reset">

                        <Button
                            variant="outlined" color="inherit"
                            size="small"
                            onClick={handleReset}
                        >Reset</Button>

                    </Tooltip >

                </Stack>

            </Stack>
            <Box
                sx={{
                    height: '60vh',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {!isLoading && showCards && filterData.length > 0 && (
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,        // space between cards
                            mt: 1,
                            px: 2
                        }}
                    >
                        <Box
                            sx={{
                                height: "419px",
                                display: "flex",
                                flexDirection: "column",
                                flex: 3.6,

                            }}
                        >
                            <Card
                                sx={{
                                    p: 0,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflow: 'hidden',
                                }}
                            >


                                {/* Header */}
                                <Box
                                    sx={{
                                        p: 1,
                                        borderBottom: "1px solid #E5E5E5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    {/* Left side: Issue List + Count */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>Issue List</Typography>

                                        <Box
                                            sx={{
                                                width: "50px",
                                                height: "30px",
                                                borderRadius: "8px",
                                                boxShadow: "0px 0px 2px 0px #0000002E",
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                color: "#666060",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#fff",
                                            }}
                                        >
                                            {filteredServiceData?.length || 0}
                                        </Box>
                                    </Box>

                                    {/* Right side: Search */}
                                    <Box display="flex" alignItems="center" gap={1}>

                                        <TextField
                                            size="small"
                                            placeholder="Search By Issue ID"
                                            value={searchIssueId}
                                            onChange={(e) => setSearchIssueId(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <ManageSearchOutlinedIcon sx={{ color: "#989898" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            sx={{
                                                height: 35,
                                                width: 180,
                                                backgroundColor: "#FFFFFF",
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "#FFFFFF",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    backgroundColor: "#FFFFFF",
                                                },
                                            }}
                                        />
                                        <Tooltip title="Export To Excel" >

                                            <IconButton
                                                sx={{
                                                    width: 38,
                                                    height: 35,
                                                    backgroundColor: "#FFFFFF",
                                                    border: "1px solid #E0E0E0",
                                                    borderRadius: "8px",
                                                    color: '#ABABAB',
                                                    "&:hover": {
                                                        backgroundColor: '#2E7D32', // primary color fill
                                                        color: "#fff",                                           // text white
                                                        borderColor: '1px solid #2E7D32',
                                                    },
                                                }}
                                                onClick={exportToExcel}
                                            >
                                                <FileDownloadOutlinedIcon sx={{ width: 20, height: 20 }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>

                                </Box>

                                <Box
                                    sx={{
                                        flex: 1,
                                        minHeight: 0,
                                        overflowY: "auto",
                                        p: 1.5,

                                    }}

                                >
                                    {Array.isArray(filteredServiceData) && filteredServiceData.length > 0 && (
                                        filteredServiceData.map((issue, index) => (
                                            <Card
                                                key={index}
                                                sx={{
                                                    borderRadius: 2,
                                                    boxShadow: 'none',
                                                    border:
                                                        selectedIssue?.IssueId === issue.IssueId
                                                            ? '1px solid #3C97FF'
                                                            : '1px solid #E5E5E5',
                                                    height: 'auto',
                                                    minHeight: 'unset',
                                                    alignSelf: 'flex-start',
                                                    mb: 1
                                                }}
                                                onClick={() => handleIssueCardClick(issue)}
                                            >

                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems="flex-start"
                                                    px={1}
                                                    pt={1}
                                                    gap={1}
                                                >
                                                    {/* Left Side */}
                                                    <Box
                                                        display="flex"
                                                        flexWrap="wrap"
                                                        alignItems="center"
                                                        gap={2}
                                                        sx={{ flex: 1, minWidth: 0 }}
                                                    >
                                                        {/* Displaying the Issue ID */}
                                                        <Typography
                                                            variant="subtitle2"
                                                            sx={{
                                                                color: '#FC3838',
                                                                fontWeight: 700,
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            {issue.IssueId}
                                                        </Typography>

                                                        {/* Displaying the remarks */}
                                                        <Typography
                                                            variant="subtitle1"
                                                            fontWeight={600}
                                                            sx={{
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word',
                                                                overflowWrap: 'break-word',
                                                            }}
                                                        >
                                                            {issue.SiteName}
                                                        </Typography>

                                                    </Box>


                                                </Box>

                                                <CardContent sx={{ p: 1, }}>

                                                    <Grid container spacing={1} alignItems="flex-start" >
                                                        <Grid container item xs={12} rowSpacing={0}>
                                                            <Grid item xs={6}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                    <ContentPasteSearchRoundedIcon sx={{ color: '#9A9A9A', width: 14, height: 14 }} />
                                                                    <Typography sx={{ color: '#9A9A9A', fontWeight: 500, fontSize: 10 }}>
                                                                        Issue Category
                                                                    </Typography>
                                                                </Box>

                                                                <Typography variant="body2" color="text.primary">
                                                                    {issue.IssueCategory}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                    <CalendarMonthIcon sx={{ color: '#9A9A9A', width: 14, height: 14 }} />
                                                                    <Typography sx={{ color: '#9A9A9A', fontWeight: 500, fontSize: 10 }}>
                                                                        Issue Date
                                                                    </Typography>
                                                                </Box>

                                                                <Typography variant="body2" color="text.primary">
                                                                    {issue.CreatedDate ? format(new Date(issue.CreatedDate), 'dd-MMM-yyyy HH,mm') : ''}
                                                                </Typography>
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        )))}

                                    {!showCards && (

                                        <Box
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                px: 2,
                                            }}
                                        >
                                            <Typography sx={{ color: '#928A8A', fontWeight: 500, fontSize: 16 }}>
                                                No data available
                                            </Typography>

                                        </Box>
                                    )}
                                </Box>

                            </Card>
                        </Box>

                        <Card
                            sx={{
                                p: 0,
                                height: "412px",
                                mt: 1,
                                display: "flex",
                                flexDirection: "column",
                                flex: 3.5,
                                minWidth: 0,
                                boxShadow: "none",
                                border: '1px solid #E5E5E5'
                            }}
                        >
                            {/* Header */}

                            <Box
                                sx={{
                                    p: 1,
                                    borderBottom: "1px solid #E5E5E5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* Left side: Issue List + Count */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>Issue Details</Typography>

                                    <Box
                                        sx={{
                                            display: "inline-flex",      // shrink to fit content
                                            minWidth: "40px",            // minimum width for small numbers
                                            maxWidth: "120px",           // optional: prevents it from being too wide
                                            height: "30px",
                                            px: 2,                       // horizontal padding
                                            borderRadius: "8px",
                                            boxShadow: "0px 0px 2px 0px #0000002E",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            color: "#666060",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#fff",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",        // prevent wrapping
                                            overflow: "hidden",          // hide overflow if too long
                                            textOverflow: "ellipsis",    // show "..." if text is too long
                                        }}
                                    >
                                        {selectedIssue?.IssueId || 0}
                                    </Box>

                                </Box>

                                {/* Right side: Pending Time */}
                                {selectedIssue && (
                                    <Card
                                        sx={{
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            px: 1.5,
                                            border: statusWiseStyle.border,
                                            backgroundColor: statusWiseStyle.bg,
                                            display: 'inline-flex',     // 🔑 shrink to content
                                            alignItems: 'center',
                                            height: '30px',
                                            flexShrink: 0,              // 🔑 prevent cutting when sidebar opens
                                            maxWidth: '100%',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: statusWiseStyle.textColor,
                                                fontWeight: 500,
                                                fontSize: 14,
                                                whiteSpace: 'nowrap',     // 🔑 keep in one line
                                            }}
                                        >
                                            {selectedIssue?.PendingTime || ""}
                                        </Typography>
                                    </Card>
                                )}


                            </Box>

                            {selectedIssue ? (
                                <>
                                    <Box
                                        sx={{
                                            pt: 1,
                                            px: 1,
                                            overflowY: "auto",
                                            flex: 1,
                                            position: 'relative',
                                        }}
                                    >
                                        <CardContent sx={{ p: 1, }}>
                                            <Box sx={{ height: '130px' }} >
                                                <Grid container spacing={1} >
                                                    <Grid container item xs={12} columnSpacing={2} rowSpacing={0} alignItems="flex-start">

                                                        {/* Distributor */}
                                                        <Grid item xs={8}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                                                <Typography sx={{ color: '#9A9A9A', fontWeight: 500, fontSize: 10 }}>
                                                                    Distributor
                                                                </Typography>
                                                            </Box>

                                                            <Typography
                                                                variant="body2"
                                                                fontWeight={700}
                                                                color="text.primary"
                                                                sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                                                            >
                                                                {selectedIssue?.SiteName || ""}
                                                            </Typography>
                                                        </Grid>

                                                        {/* Status */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                                <Typography variant="caption" sx={{ color: '#9A9A9A', fontWeight: 500 }}>
                                                                    Status
                                                                </Typography>
                                                            </Box>

                                                            <Typography
                                                                variant="body2"
                                                                color="text.primary"
                                                                sx={{ whiteSpace: 'nowrap' }}
                                                            >
                                                                {selectedIssue?.StatusName || ""}
                                                            </Typography>
                                                        </Grid>

                                                    </Grid>

                                                    <Grid container item xs={12} rowSpacing={0}>

                                                        <Grid item xs={12}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                <Typography sx={{ color: '#9A9A9A', fontWeight: 500, fontSize: 10 }}>
                                                                    Issue Remark

                                                                </Typography>
                                                            </Box>

                                                            <Typography component="span" variant="body2" color="text.primary" dangerouslySetInnerHTML={{
                                                                __html: (selectedIssue?.IssueRemark || "").replace(/\n/g, "<br/>"),
                                                            }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                        </CardContent>
                                    </Box>
                                    <Box
                                        sx={{
                                            p: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Card sx={{
                                            borderRadius: 2, boxShadow: 'none', p: 1, border: ' 1px solid #E5E5E5', backgroundColor: '#FFFFFF', height: '100px', width: '100%'
                                        }} onClick={handelReasonOpenClick}>
                                            <Grid container spacing={1} >
                                                <Grid container item xs={12} rowSpacing={0}>
                                                    <Grid item xs={12}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <ErrorOutlineRoundedIcon sx={{ color: '#F54A00', width: 17, height: 17 }} />
                                                            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
                                                                RCA
                                                            </Typography>
                                                        </Box>

                                                        <textarea
                                                            value={rcaSolutionPreview || "No RCA details available"}
                                                            readOnly
                                                            style={{
                                                                width: '100%',
                                                                height: '60px',
                                                                resize: 'none',
                                                                border: 'none',
                                                                outline: 'none',
                                                                fontSize: '12px',
                                                                fontWeight: 400,
                                                                overflowY: 'auto',
                                                                backgroundColor: '#FFFFFF',
                                                            }}
                                                        />

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                        <Modal open={reasonOpenModal} onClose={handelReasonCancelClick}>
                                            <Box sx={{
                                                ...historyModalStyle,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                maxHeight: '90vh',
                                                overflow: 'hidden',
                                            }}>
                                                {/* Sticky Header */}
                                                <Box
                                                    sx={{
                                                        position: 'sticky',
                                                        top: 0,
                                                        backgroundColor: '#fff',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '0px 16px',
                                                            borderBottom: '1px solid #E0E0E0',
                                                            backgroundColor: '#fff',
                                                            m: 0, // remove outer margins
                                                        }}
                                                    >
                                                        <Typography variant="h6" color="text.primary" fontWeight="bold">
                                                            Issue RCA
                                                        </Typography>
                                                        <IconButton onClick={handelReasonCancelClick}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Box>
                                                </Box>

                                                {/* Scrollable Content */}
                                                <Box
                                                    sx={{
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        display: 'flex',

                                                    }}
                                                >

                                                    <Box
                                                        sx={{
                                                            flex: 1,
                                                            overflowY: "auto",
                                                            p: 2,
                                                        }}
                                                    >
                                                        <Stack spacing={1}>

                                                            {/* RCA Date */}
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>RCA Date</FormLabel>
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        inputFormat="dd/MMM/yyyy"
                                                                        value={rcaDate}
                                                                        disabled
                                                                        renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                                                                    />
                                                                </LocalizationProvider>
                                                            </FormControl>

                                                            {/* RCA Reason Dropdown */}
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>Issue RCA Reason</FormLabel>
                                                                <Autocomplete
                                                                    fullWidth

                                                                    size="small"
                                                                    id="rcareason"
                                                                    value={selectedReasonDdl.find((option) => option.id === reasonDdl) || ""}
                                                                    disabled
                                                                    options={selectedReasonDdl}
                                                                    getOptionLabel={(option) => option.Description || ""}
                                                                    renderInput={(params) => <TextField {...params}
                                                                        placeholder="Select Reason" />}
                                                                    limitTags={2}
                                                                />

                                                            </FormControl>

                                                            {/* RCA Reason Details */}
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>Issue RCA Reason Details</FormLabel>
                                                                <TextareaAutosize
                                                                    minRows={3}
                                                                    placeholder="Describe the events or conditions that directly caused this issue..."
                                                                    value={reasonTxt}
                                                                    disabled
                                                                    style={{
                                                                        width: "100%",
                                                                        resize: "none",

                                                                        border: "1px solid #E5E5E5",
                                                                        borderRadius: "4px",
                                                                        padding: "8px",
                                                                    }}
                                                                />
                                                            </FormControl>

                                                            {/* RCA Solution */}
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>Issue RCA Solution</FormLabel>
                                                                <TextareaAutosize
                                                                    minRows={3}
                                                                    placeholder="Describe proposed solution…"
                                                                    value={solution}
                                                                    disabled
                                                                    style={{
                                                                        width: "100%",
                                                                        resize: "none",

                                                                        border: "1px solid #E5E5E5",
                                                                        borderRadius: "4px",
                                                                        padding: "8px",
                                                                    }}
                                                                />
                                                            </FormControl>

                                                            {/* Recurring */}
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>Recurring</FormLabel>
                                                                <Select
                                                                    size="small"
                                                                    value={recurring}
                                                                    disabled
                                                                    MenuProps={{
                                                                        PaperProps: {
                                                                            sx: {
                                                                                backgroundColor: '#fbe9e7',
                                                                                maxHeight: '200px',
                                                                                width: '200px',
                                                                            },
                                                                        },
                                                                    }}
                                                                >
                                                                    {RecurringDropdown.map((reason) => (
                                                                        <MenuItem key={reason.Id} value={reason.Id}>
                                                                            {reason.value}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>

                                                            {/* Occurrence */}
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>Occurrence</FormLabel>
                                                                <TextareaAutosize
                                                                    minRows={3}
                                                                    placeholder="Mention how often this issue occurs..."
                                                                    value={occurrence}
                                                                    disabled
                                                                    style={{
                                                                        width: "100%",
                                                                        resize: "none",

                                                                        border: "1px solid #E5E5E5",
                                                                        borderRadius: "4px",
                                                                        padding: "8px",
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </Stack>
                                                    </Box>

                                                </Box>
                                            </Box>
                                        </Modal>
                                    </Box>
                                </>
                            ) : (
                                <Box
                                    sx={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        px: 2,
                                    }}
                                >
                                    <Typography sx={{ color: '#928A8A', fontWeight: 500, fontSize: 16 }}>
                                        Issue not selected
                                    </Typography>
                                    <Typography sx={{ color: '#928A8A', fontWeight: 400, fontSize: 12 }}>
                                        Select an issue from the Issue List to view its details.
                                    </Typography>
                                </Box>
                            )}
                        </Card>

                        <Card
                            sx={{
                                p: 0,
                                height: "412px",
                                mt: 1,
                                display: "flex",
                                flexDirection: "column",
                                flex: 2.9,
                                minWidth: 0,
                                boxShadow: "none",
                                border: '1px solid #E5E5E5'
                            }}
                        >
                            {/* Header */}
                            <Box
                                sx={{
                                    p: 1,
                                    borderBottom: "1px solid #E5E5E5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>Service History</Typography>
                            </Box>
                            {selectedIssue ? (
                                <>
                                    <Box
                                        sx={{
                                            p: 1.5,
                                            pb: 1,
                                            overflowY: "auto",
                                            flex: 1,
                                            position: 'relative',
                                        }}
                                    >

                                        <Timeline
                                            sx={{
                                                p: 0,
                                                m: 0,
                                                alignItems: 'flex-start',
                                                '& .MuiTimelineItem-root:before': {
                                                    display: 'none',
                                                },
                                            }}
                                        >
                                            {serviceHistoryData?.map((history, index) => (
                                                <TimelineItem key={index} sx={{
                                                    width: '100%',
                                                }}>
                                                    <TimelineSeparator>
                                                        {/*  Dot */}
                                                        <TimelineDot
                                                            sx={{
                                                                backgroundColor: '#2B7FFF',
                                                                width: 10,
                                                                height: 10,
                                                                boxShadow: 'none',
                                                                m: 0,
                                                            }}
                                                        />

                                                        {/* Continuous line */}
                                                        {index !== serviceHistoryData?.length - 1 && (
                                                            <TimelineConnector
                                                                sx={{
                                                                    backgroundColor: '#B7C1D0',
                                                                    width: '1px',
                                                                    minHeight: 40,
                                                                }}
                                                            />
                                                        )}
                                                    </TimelineSeparator>

                                                    <TimelineContent
                                                        sx={{
                                                            py: 0,
                                                            px: 1,
                                                            width: '100%',
                                                            display: 'flex',
                                                        }}
                                                    >

                                                        <Card
                                                            sx={{
                                                                borderRadius: 2,
                                                                boxShadow: 'none',
                                                                border: '1px solid #E5E5E5',
                                                                mb: 2,
                                                                width: '100%',
                                                                alignSelf: 'stretch',
                                                            }}
                                                        >

                                                            <Box
                                                                display="flex"
                                                                justifyContent="space-between"
                                                                alignItems="flex-start"
                                                                px={1}
                                                                pt={1}
                                                                gap={1}
                                                            >
                                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            alignItems: 'center',
                                                                            mb: 0.5,
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: 0.5,
                                                                                minWidth: 0, // important for ellipsis to work
                                                                                overflow: 'hidden',
                                                                            }}
                                                                        >
                                                                            <PersonOutlineOutlinedIcon
                                                                                sx={{ color: '#717883', width: 16, height: 16, flexShrink: 0 }}
                                                                            />

                                                                            <Tooltip title={history?.DisplayName} arrow>
                                                                                <Typography
                                                                                    sx={{
                                                                                        fontWeight: 500,
                                                                                        fontSize: 12,
                                                                                        whiteSpace: 'nowrap',
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        cursor: 'pointer',
                                                                                    }}
                                                                                >
                                                                                    {history?.DisplayName}
                                                                                </Typography>
                                                                            </Tooltip>
                                                                        </Box>

                                                                        <Typography
                                                                            sx={{
                                                                                fontWeight: 500,
                                                                                fontSize: 12,
                                                                                color: '#ABA6A6',
                                                                                flexShrink: 0, // ensures date does not shrink
                                                                                marginLeft: 1,
                                                                            }}
                                                                        >
                                                                            {history?.Date}
                                                                        </Typography>
                                                                    </Box>


                                                                    <Typography
                                                                        sx={{
                                                                            color: '#717883',
                                                                            fontSize: 12,
                                                                            wordBreak: 'break-word',
                                                                        }}
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: (history?.ServiceProvided || "").replace(/\n/g, "<br/>"),
                                                                        }}
                                                                    />

                                                                </Box>
                                                            </Box>
                                                        </Card>
                                                    </TimelineContent>
                                                </TimelineItem>
                                            ))}
                                        </Timeline>

                                    </Box>

                                    <Box
                                        sx={{
                                            p: 1,
                                            border: "1px solid #E5E5E5",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Tooltip
                                            title={comment?.trim() || ''}
                                            arrow
                                            placement="top"
                                            disableHoverListener={!comment?.trim()} // no tooltip if empty
                                        >

                                            <TextField
                                                fullWidth
                                                size="small"
                                                value={comment}
                                                onChange={handleComment}
                                                placeholder="Enter Your thoughts here...."
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        height: 48,              // 
                                                        paddingRight: '4px',     // keeps icon tight to the right
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '12px 14px',    // vertical centering of text
                                                    },
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" sx={{ marginRight: 0 }}>
                                                            <IconButton
                                                                onClick={handleSend}
                                                                sx={{
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                <Icon
                                                                    icon="mdi:send-circle"
                                                                    width="35"
                                                                    height="35"
                                                                    style={{
                                                                        color: comment?.trim()
                                                                            ? '#2E7D32'
                                                                            : '#BABABA',  //  default
                                                                        transition: 'color 0.2s ease',
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Tooltip>
                                    </Box>
                                </>
                            ) : (
                                <Box
                                    sx={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        px: 2,
                                    }}
                                >
                                    <Typography sx={{ color: '#928A8A', fontWeight: 500, fontSize: 16 }}>
                                        Issue not selected
                                    </Typography>
                                    <Typography sx={{ color: '#928A8A', fontWeight: 400, fontSize: 12 }}>
                                        Select an issue from the Issue List to view its service history.
                                    </Typography>
                                </Box>
                            )}
                        </Card>
                    </Box >
                )
                }
                {
                    !showCards && (
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                px: 2,
                            }}
                        >
                            <Typography sx={{ color: '#928A8A', fontWeight: 500, fontSize: 16 }}>
                                No Data
                            </Typography>

                        </Box>
                    )
                }
            </Box >
            {/* ----------------------------------------------------------------- */}


            {isLoading && (<LoadingProgressBar sx={{ py: 9 }} />)}
        </Page >


    );
}